import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface WordRequest {
    event_category_idx: number;
    wreath_word: string;
    search_word: string;
}

export const usePostWord = (successCallback?: (wordIdx: number) => void) => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation({
        mutationFn: async (wordData: WordRequest) => {
            const response = await axios.post(enum_api_uri.post_word, wordData, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            return response.data.data.word_idx;
        },
        onSuccess: wordIdx => {
            queryClient.invalidateQueries({ queryKey: ["getWordList"] });
            successCallback?.(wordIdx);
        },
    });
};
